/**
 * The guidance shown to the buyer under a personalisation field.
 *
 * `hint` is the author's own wording; the character cap is derived. They share
 * one line so a field configured with both does not sprout a second note under
 * its label. Shared by the in-page personalizer and the editor's own
 * personalize panel, so the buyer reads the same guidance whichever
 * personalisation mode the product uses.
 */
function buildFieldHint(
  hint: string | undefined,
  maxCharCount: number | undefined,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  return [hint, maxCharCount && t('editor-max-characters', { maxCharacters: maxCharCount })].filter(Boolean).join(' ');
}

export default buildFieldHint;
